module.exports = __webpack_public_path__ + "static/media/Workforce_Management.4bf8c748.png";